import script from "./e-color-group.vue?vue&type=script&setup=true&lang=js"
export * from "./e-color-group.vue?vue&type=script&setup=true&lang=js"

import "./e-color-group.vue?vue&type=style&index=0&id=7497b892&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7497b892"]])

export default __exports__